const DEVICE_VIEW_CACHE_VERSION = 1;
export const DEVICE_VIEW_CACHE_TTL_MS = 5 * 60 * 1000;

const normalizeParams = (params = {}) =>
  Object.entries(params)
    .filter(([, value]) => value !== undefined && value !== null && value !== "")
    .sort(([a], [b]) => a.localeCompare(b));

export const buildDeviceViewCacheKey = (scope, { userId, params = {} } = {}) => {
  const normalizedScope = String(scope || "device-view").trim() || "device-view";
  const normalizedUserId = String(userId || "anonymous").trim() || "anonymous";
  return `gps:${normalizedScope}:v${DEVICE_VIEW_CACHE_VERSION}:${normalizedUserId}:${JSON.stringify(
    normalizeParams(params)
  )}`;
};

export const readDeviceViewCache = (
  scope,
  { userId, params = {}, ttlMs = DEVICE_VIEW_CACHE_TTL_MS } = {}
) => {
  try {
    if (typeof localStorage === "undefined") return null;
    const cacheKey = buildDeviceViewCacheKey(scope, { userId, params });
    const raw = localStorage.getItem(cacheKey);
    if (!raw) return null;

    const parsed = JSON.parse(raw);
    const createdAt = Number(parsed?.createdAt || 0);
    if (!createdAt || Date.now() - createdAt > ttlMs) {
      localStorage.removeItem(cacheKey);
      return null;
    }

    return parsed?.payload ?? null;
  } catch (_) {
    return null;
  }
};

export const writeDeviceViewCache = (scope, { userId, params = {}, payload } = {}) => {
  try {
    if (typeof localStorage === "undefined") return;
    const cacheKey = buildDeviceViewCacheKey(scope, { userId, params });
    localStorage.setItem(
      cacheKey,
      JSON.stringify({
        createdAt: Date.now(),
        payload: payload ?? null,
      })
    );
  } catch (_) {
    // Ignore localStorage quota/serialization failures quietly.
  }
};
